// extracted by mini-css-extract-plugin
export default {"row":"style_row__u63jj","icon":"style_icon__JYzNe","switch":"style_switch__dAqhg","toggle":"style_toggle__xZ2ll","slider":"style_slider__4FoF+"};